/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_IntroInputs */



/**
* | output |
* | --- |
* | "Papyria is a Norwegian company building tools for proofreading and copy-editing. Fagbokforlaget is a co-owner of the company and develops the tools with us." |
*
* @param {Landing_IntroInputs} inputs
* @param {{ locale?: "nb-NO" | "en-GB" | "sv-SE" }} options
* @returns {LocalizedString}
*/
export const landing_intro = /** @type {((inputs?: Landing_IntroInputs, options?: { locale?: "nb-NO" | "en-GB" | "sv-SE" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_IntroInputs, { locale?: "nb-NO" | "en-GB" | "sv-SE" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en-GB") return /** @type {LocalizedString} */ ("Papyria is a Norwegian company building tools for proofreading and copy-editing. Fagbokforlaget is a co-owner of the company and develops the tools with us.")
	if (locale === "sv-SE") return /** @type {LocalizedString} */ ("Papyria är ett norskt företag som utvecklar verktyg för korrektur och språkgranskning. Fagbokforlaget är delägare i företaget och utvecklar verktygen tillsammans med oss.")
	return /** @type {LocalizedString} */ ("Papyria er et norsk selskap som utvikler verktøy for korrektur og språkvask. Fagbokforlaget er medeier i selskapet og utvikler verktøyene sammen med oss.")
});